export enum TaskStatus {
  OFFEN = 'OFFEN',
  IN_BEARBEITUNG = 'IN_BEARBEITUNG',
  ERLEDIGT = 'ERLEDIGT',
  WARTET = 'WARTET',
  ZURUECK_GESTELLT = 'ZURUECK_GESTELLT',
}
